import { render, staticRenderFns } from "./insurance-topup-brick.vue?vue&type=template&id=a1d5b6aa&scoped=true"
import script from "./insurance-topup-brick.vue?vue&type=script&lang=js"
export * from "./insurance-topup-brick.vue?vue&type=script&lang=js"
import style0 from "./insurance-topup-brick.vue?vue&type=style&index=0&id=a1d5b6aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d5b6aa",
  null
  
)

export default component.exports